export const notEnoughTokensErrorMessage =
	'You need to replenish your balance in order to perform further requests';
